import { RouteRecordRaw } from 'vue-router'
import adminGameRoutes from './admin/game'
import adminLogsRoutes from './admin/logs'
import adminTicketRoutes from './admin/ticket'
import adminManagerRoutes from './admin/manager'
import adminGameDataRoutes from './admin/game_data'
import adminUserRoutes from './admin/user'
import adminPrizeRoutes from './admin/prize'
import adminBusinessRoutes from './admin/business'

const adminRoutes: RouteRecordRaw[] = [
  ...adminGameRoutes,
  ...adminGameDataRoutes,
  ...adminUserRoutes,
  ...adminTicketRoutes,
  ...adminPrizeRoutes,
  ...adminBusinessRoutes,
  ...adminManagerRoutes,
  ...adminLogsRoutes
]

export default adminRoutes
